import axios from 'axios';
import { AllContent } from '../types';

const API_URL = import.meta.env.VITE_API_URL || 'http://0.0.0.0:8055';

export const searchAllContent = async (
  searchQuery: string
): Promise<AllContent[]> => {
  if (searchQuery.length < 2) {
    return [];
  }

  const params = {
    fields: [
      'id',
      'translations.*',
      'category.id',
      'category.slug',
      'category.translations.*',
      'subcategories.subcategories_id.translations.*',
      'subcategories.subcategories_id',
      'subcategories.translations.*',
      'tags.tags_id.translations.*',
      'tags.tags_id',
      'tags.translations.*',
      'slug',
      'tiles.translations.*',
      'grids.template.translations.*'
    ],
    filter: {
      _or: [
        {
          translations: {
            title: {
              _contains: searchQuery,
            },
          },
        },
        {
          translations: {
            description: {
              _contains: searchQuery,
            },
          },
        },

        {
          tiles:
          {
            translations: {
              text: {
                _contains: searchQuery,
              },
            },
          }
        },
        {
          grids:
          {
            template:{
            translations: {
              text: {
                _contains: searchQuery,
              },
            },
          },
          }
        },
      ],
    },
    limit: 10,
  };

  try {
    const response = await axios.get(`${API_URL}/items/allContent`, { params });

    return response.data.data;
  } catch (error) {
    console.error('Error searching content:', error);
    if (axios.isAxiosError(error)) {
      console.error('Axios error details:', error.response?.data);
    }
    throw error;
  }
};
